module.exports = __webpack_public_path__ + "img/detail.16367433.png";